import { getAccessToken } from '@/helpers/auth-helper'

import { ROUTES } from '@/constants/routes'

export default function isAuth({ next, router, store }) {
    if (!getAccessToken()) {
        return router.push({ name: ROUTES.login })
    }

    store.setIsUserLogin(true)

    next()
}
